import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { inputBaseClasses } from '@mui/material/InputBase';
import { inputAdornmentClasses } from '@mui/material/InputAdornment';

const getDefaultBorder = theme => `1px solid ${theme.palette.divider}`;
const getFocusedBorder = theme => `2px solid ${theme.palette.primary.main}`;
const getErrorFocusedBorder = theme => `2px solid ${theme.palette.error.main}`;
const getHoverBorder = theme => `1px solid ${theme.palette.grey[800]}`;
const getErrorBorder = theme => `1px solid ${theme.palette.error.main}`;

export const textFieldOverride = {
  MuiTextField: {
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        width: !ownerState.fullWidth && theme.sizes?.textField[ownerState.size],
        [`& .${outlinedInputClasses.adornedEnd}`]: {
          paddingRight: theme.spacing(1)
        },
        [`& .${outlinedInputClasses.adornedStart}`]: {
          paddingLeft: theme.spacing(1),
          [`& .${inputAdornmentClasses.positionStart}`]: {
            marginRight: 0
          }
        },
        [`& .${inputBaseClasses.root}`]: {
          backgroundColor: theme.palette.background.paper,
          [`& .${outlinedInputClasses.notchedOutline}`]: {
            border: getDefaultBorder(theme),
            '&:hover': {
              border: getHoverBorder(theme)
            }
          },
          [`&.${inputBaseClasses.focused}`]: {
            [`& .${outlinedInputClasses.notchedOutline}`]: {
              border: getFocusedBorder(theme),
              '&:hover': {
                border: getFocusedBorder(theme)
              }
            }
          },
          [`&.${inputBaseClasses.readOnly}`]: {
            backgroundColor: theme.palette.background.default,
            [`& .${outlinedInputClasses.notchedOutline}`]: {
              border: getDefaultBorder(theme),
              '&:hover': {
                border: getDefaultBorder(theme)
              }
            }
          },
          [`&.${inputBaseClasses.disabled}`]: {
            backgroundColor: theme.palette.action.disabledBackground,
            color: theme.palette.text.disabled,
            [`& .${outlinedInputClasses.notchedOutline}`]: {
              border: getDefaultBorder(theme)
            }
          },
          [`&.${inputBaseClasses.error}`]: {
            [`& .${outlinedInputClasses.notchedOutline}`]: {
              border: getErrorBorder(theme),
              '&:hover': {
                border: getErrorBorder(theme)
              }
            },
            // Need to target the focused class specifically because the focus border is defined using classes
            [`&.${inputBaseClasses.focused}`]: {
              [`& .${outlinedInputClasses.notchedOutline}`]: {
                border: getErrorFocusedBorder(theme)
              }
            }
          }
        },
        [`& .${inputBaseClasses.input}`]: {
          textOverflow: 'ellipsis',
          width: '100%',
          height: 'auto',
          padding: ownerState.multiline ? 0 : theme.spacing(1, 0, 1, 1),
          ...theme.typography.body1,
          color: theme.palette.text.primary,
          '&::placeholder': {
            color: theme.palette.text.hint,
            opacity: 1
          },
          '&:-webkit-autofill': {
            transition: 'background-color 5000s ease-in-out 0s',
            WebkitBackgroundColor: 'transparent',
            WebkitBackground: 'transparent',
            '&::first-line': {
              ...theme.typography.body1
            }
          }
        },
        [`& .${inputBaseClasses.inputSizeSmall}`]: {
          paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          ...theme.typography.body1
        },
        [`& .${inputBaseClasses.multiline}`]: {
          padding: ownerState.multiline && theme.spacing(1)
        }
      })
    }
  }
};
